import React from "react";
import { Link } from "react-router-dom";
import {
  FaBookOpen,
  FaSearch,
  FaPen,
  FaComments,
  FaUser,
  FaInbox,
} from "react-icons/fa";

export default function EmptyState({
  icon = "default",
  title,
  message,
  action,
  actionLabel,
  actionLink,
  className = "",
}) {
  const getIcon = () => {
    const iconClass = "w-16 h-16 text-[#ffd4bc] mb-4";
    switch (icon) {
      case "poem":
        return <FaBookOpen className={iconClass} aria-hidden="true" />;
      case "search":
        return <FaSearch className={iconClass} aria-hidden="true" />;
      case "write":
        return <FaPen className={iconClass} aria-hidden="true" />;
      case "comments":
        return <FaComments className={iconClass} aria-hidden="true" />;
      case "user":
        return <FaUser className={iconClass} aria-hidden="true" />;
      case "inbox":
        return <FaInbox className={iconClass} aria-hidden="true" />;
      default:
        return <FaBookOpen className={iconClass} aria-hidden="true" />;
    }
  };

  return (
    <div
      className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}
      role="status"
      aria-live="polite"
    >
      <div className="mb-4">{getIcon()}</div>
      {title && (
        <h2 className="text-xl sm:text-2xl font-bold text-[#333333] mb-2">
          {title}
        </h2>
      )}
      {message && (
        <p className="text-[#777777] text-sm sm:text-base max-w-md mb-6">
          {message}
        </p>
      )}
      {action && actionLabel && actionLink && (
        <Link
          to={actionLink}
          className="peer-home-btn-primary inline-flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f26522]"
          aria-label={actionLabel}
        >
          {action === "write" && <FaPen className="w-4 h-4" aria-hidden="true" />}
          {actionLabel}
        </Link>
      )}
      {action && actionLabel && !actionLink && (
        <button
          onClick={action}
          className="peer-home-btn-primary inline-flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f26522]"
          aria-label={actionLabel}
        >
          {action === "write" && <FaPen className="w-4 h-4" aria-hidden="true" />}
          {actionLabel}
        </button>
      )}
    </div>
  );
}

